import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

/**
 * Düğümün ilgili kişi satırı (`/data-datasubject`): envanter ekranı notu buradan günceller; silme/sayfalama crud modülünden.
 * TKP-27 / 6.4c-2: eski oluşturma/güncelleme (kaynak×veri satırına bağlı) ve kaynak-ilgili kişi uçları kalktı — oluşturma
 * düğüm yüzeyinde (`organizationProcessDataDatasubject`).
 */
export const organizationDataDatasubject = createCrudVuexModule({
  namespaced: true,
  path: "/data-datasubject",
  options: { localizedFields: ["name", "description", "note"] },
  actions: {
    async updateNote({ commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        payload = await dispatch("preparePayload", { editedEntity: {}, form: payload });
        const response = await rest.put(`/data-datasubject/note`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },

  mutations: {},
});
